import angular from 'angular'

import template from '../../../templates/register-closure/wr-print-register-closure.html'

/**
 * Directive for printing register closure information.
 *
 * @module webregister.directives.wrPrintRegisterClosure
 */
angular
  .module('webregister.directives')
  .directive('wrPrintRegisterClosure', function () {
    return {
      scope: {
        data: '=',
      },
      template,
      controllerAs: 'wrPrintRegisterClosureCtrl',
      bindToController: true,
      controller(this: $TSFixMe, userManager) {
        this.user = userManager.getLoggedInUser()
      },
    }
  })
